import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class BikeShopPostsService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getPosts(PartnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/BikeShopPosts/list/${PartnerID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  createPost(Data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(this.env.url + `/BikeShopPosts?code=${this.env.key}`, Data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updatePost(Data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(this.env.url + `/BikeShopPosts?code=${this.env.key}`, Data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deletePost(PostID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url + `/BikeShopPosts/${PostID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
